import React, { Component } from 'react';
import { Motion, spring, presets } from "react-motion";

class MessageBox extends Component {
    constructor(props) {
        super(props);

        this.timeToDelete = "";
        this.handler = null;
        this.visible = false;

        this.handleRest = this.handleRest.bind(this);
        //console.log("I am called ", this.visible);
    }

    handleRest() {
        if (this.timeToDelete === "") {
            this.handler = setTimeout(this.callMe.bind(this), 6000);

        }
        if (this.timeToDelete === "yes") {
            this.props.context.messageBox = null;
            this.visible = false;
            this.timeToDelete = "";
            this.props.context.forceUpdate();

            //this.setState({ visible: false });
        }

    }

    callMe() {
        this.timeToDelete = "yes";
        this.visible = true;
        this.setState({});

    }

    componentWillUnmount() {
        //this.visible = false;
        clearTimeout(this.handler);
    }

    render() {
        //console.log("render called", this.visible);
        return (
            <Motion defaultStyle={{ x: -1 }} style={{ x: this.visible ? spring(-1, presets.stiff) : spring(0, presets.stiff) }} onRest={this.handleRest}>
                {({ x }) => {
                    return (
                        <div id="messageBox" style={{ transform: `translateX(${x * 500}px)`, backgroundColor: this.props.status ? "#6a967e" : "#de6a74" }}>
                            <p>{this.props.message}</p>
                            <audio autoPlay="autoplay">
                                <source src={this.props.status ? '/success.wav' : '/chord.wav'} type="audio/wav" />
                            </audio>
                        </div>
                    );
                }}

            </Motion>

        );
    }

    static showMessage(message, status, context) {
        //console.log("-------", message, context);
        if (!message || !context || typeof status !== "boolean") throw new Error("plz provide a message string status as boolean and component (this) as context");

        let messageBox = <MessageBox message={message} status={status} context={context} />;
        //console.log(messageBox);
        return messageBox;
    }
}

export default MessageBox;


// WEBPACK FOOTER //
// ./src/jsx/components/utility/message-box.jsx